module.exports = __webpack_public_path__ + "static/img/NSW-19.08c7cf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-19.jpg
// module id = d3UX
// module chunks = 0